<template>
  <div>
    admin index
  </div>
</template>
<script>
  export default {
  }
</script>
